<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToList">
      <div slot="content">
        <lk-card>
          <lk-form
            ref="form"
            label-position="right"
            :model="formModel"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="销项税率修改明细:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                  <span class="red"> 修改销项税率可能影响财务报表期初数据，请务必获得财务人员确认后再修改！</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <div class="" style="margin-left: 134px;">
                  <lk-table border :columns="columns" :data="formModel.tableData">
                    <template slot-scope="{ row, index }" slot="saleOrderDetailOutputTaxRate">
                      <lk-form-item
                        :prop="'tableData.' + index + '.saleOrderDetailOutputTaxRate'"
                        :label-width="0"
                        :rules="formRules">
                        <lk-select
                          clearable
                          transfer
                          placeholder="请选择"
                          v-model="row.saleOrderDetailOutputTaxRate"
                          @on-change="validFormItem($event, row, index)"
                          class="item">
                          <lk-option v-for="(item) in taxRateList" :key="item.value" :value="item.value">{{item.name}}</lk-option>
                        </lk-select>
                      </lk-form-item>
                    </template>
                  </lk-table>
                </div>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="商品销项税率被修改，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem v-model="modalQuery.nameMix" placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
        </div>
        <div class="queryItem">
          <label>销售单号：</label>
          <lk-input class="item" v-model.trim="modalQuery.orderNo" placeholder="请输入"></lk-input>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.formModel.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import toolsGoodsMixins from '../../mixins/toolsGoodsMixins';
import sale from '../../services/sale';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';

export default {
  name: 'outputTaxRateAdd',
  mixins: [toolsGoodsMixins],
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
  },
  data() {
    return {
      formModel: {
        tableData: [],
      },
      formRules: [
        { required: true, message: '请选择...' },
      ],
      bool: ['是', '否'],
      submitConfirmVisiable: false,
      submitLoading: false,
      columns: [
        { title: '商品编码', key: 'saleOrderDetailDrugSerialCode', minWidth: 116 },
        {
          title: '通用名',
          key: 'saleOrderDetailApprovedDrugNames',
          minWidth: 130,
        },
	      { title: '销售订单号', key: 'saleOrderDetailOrderNo', minWidth: 116 },
        {
          title: '批次', key: 'saleOrderDetailGoodsBatch', minWidth: 136, tooltip: true,
        },
        {
          title: '批号', key: 'saleOrderDetailGoodsLot', minWidth: 116, tooltip: true,
        },
	      { title: '原销项税率', key: 'saleOrderDetailOriginOutputTaxRateStr', minWidth: 116 },
	      {
	      	title: '修改后销项税率',
          slot: 'saleOrderDetailOutputTaxRate',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'saleOrderDetailSpecifications',
          minWidth: 116,
        },
        { title: '生产企业', key: 'saleOrderDetailManufacturer', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                this.formModel.tableData.splice(index, 1);
                this.$Message.success('删除成功');
                this.$nextTick(() => {
                  this.formModel.tableData.forEach((item, index2) => {
                    this.validSingleItemByIndex(index2);
                  });
                });
              },
            },
          }, '删除'),
        },
      ],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        {
          title: '商品编码', key: 'saleOrderDetailDrugSerialCode', minWidth: 116,
        },
        {
          title: '通用名', key: 'saleOrderDetailApprovedDrugNames', minWidth: 130,
        },
        {
          title: '销售订单号', key: 'saleOrderDetailOrderNo', minWidth: 175,
        },
        {
          title: '批次', key: 'saleOrderDetailGoodsBatch', minWidth: 140,
        },
        {
          title: '当前销项税率', key: 'saleOrderDetailOriginOutputTaxRateStr', minWidth: 116,
        },
        {
          title: '规格', key: 'saleOrderDetailSpecifications', minWidth: 116,
        },
        {
          title: '生产企业', key: 'saleOrderDetailManufacturer', minWidth: 116,
        },
        {
          title: '批号', key: 'saleOrderDetailGoodsLot', minWidth: 130,
        },
        {
          title: '门店名称', key: 'saleOrderDetailStoreName', minWidth: 116,
        },
        {
          title: '业务日期', key: 'saleOrderDetailCreateTime', minWidth: 116,
        },
        {
          title: '商品分类', key: 'saleOrderDetailGoodsTypeName', minWidth: 116,
        },
        {
          title: '商品来源', key: 'saleOrderDetailPurchaseTypeName', minWidth: 116,
        },
        {
          title: '商品名称', key: 'saleOrderDetailGoodsName', minWidth: 116,
        },
        {
          title: '行号', key: 'saleOrderDetailLineNum', minWidth: 116,
        },
        {
          title: '是否凭处方销售', key: 'saleOrderDetailIsRX', minWidth: 120,
        },
        {
          title: '含麻药', key: 'saleOrderDetailIsEphedrine', minWidth: 116,
        },
        {
          title: '产地', key: 'saleOrderDetailOrigin', minWidth: 116,
        },
        {
          title: '剂型', key: 'saleOrderDetailDosageForm', minWidth: 116,
        },
        {
          title: '供应商', key: 'saleOrderDetailSupplierName', minWidth: 116,
        },
        {
          title: '销售单价', key: 'saleOrderDetailRetailPrice', minWidth: 116,
        },
        {
          title: '单位', key: 'saleOrderDetailGoodsUnit', minWidth: 116,
        },
        {
          title: '仓库', key: 'saleOrderDetailStorehouseName', minWidth: 116,
        },
        {
          title: '货位', key: 'saleOrderDetailAllocationName', minWidth: 116,
        },
        {
          title: '生产日期',
          key: 'saleOrderDetailManufactureDate',
          minWidth: 116,

        },
        // {
        //   title: '零售数量', key: 'retailNum', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '零售金额', key: 'retailAmount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '实际单价', key: 'saleOrderDetailRealPrice', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '销售数量', key: 'saleOrderDetailGoodsCount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '产品追溯码', key: 'saleOrderDetailTraceCode', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '税额', key: 'saleOrderDetailTotalOutputTaxDisplay', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '含税金额', key: 'saleOrderDetailAmount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '不含税金额', key: 'saleOrderDetailTotalPriceAfterTaxDisplay', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '含税成本', key: 'costAmount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '不含税成本', key: 'costAmountWithoutTax', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '含税毛利', key: 'profitAmount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '不含税毛利', key: 'profitAmountWithoutTax', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '含税毛利率', key: 'profitRate', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '不含税毛利率', key: 'profitRateWithoutTax', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '营业员', key: 'saleOrderDetailCreateUserName', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '收款方式', key: 'proceedsTypeNames', minWidth: 116, tooltip: true,
        // },
        {
          title: '是否DTP', key: 'isDtpStr', minWidth: 116,
        },
        // {
        //   title: '储存条件', key: 'storageConditionsName', minWidth: 116, tooltip: true,
        // },
        {
          title: 'GSP分类', key: 'goodsLabelsName', minWidth: 116, tooltip: true,
        },
        // {
        //   title: '退货数量', key: 'refundNumDisplay', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '退货总额', key: 'refundAmount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '不含税退货总额', key: 'refundAmountWithoutTax', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '开票日期', key: 'financeInvoiceInvoiceDate', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '发票号', key: 'financeInvoiceCode', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '发票总金额', key: 'financeInvoiceAmount', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '发票不含税金额', key: 'financeInvoiceAmountWithoutTax', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '发票税额', key: 'financeInvoiceTax', minWidth: 116, tooltip: true,
        // },
        // {
        //   title: '发票状态', key: 'financeInvoiceStatus', minWidth: 116, tooltip: true,
        // },
      ],
    };
  },
  computed: {
    taxRateList() {
      return this.$store.state.publicParams.taxRateList;
    },
  },
  methods: {
    handleToList() {
      this.$router.push({
        name: 'outputTaxRateList',
      });
    },
    validSingleItemByIndex(index) {
      this.$refs.form.validateField(`tableData.${index}.saleOrderDetailOutputTaxRate`);
    },
    validFormItem(value, item, index) {
      item.saleOrderDetailOutputTaxRate = value;
      this.formModel.tableData[index] = item;
      this.$nextTick(() => {
        this.$refs.form.validate();
      });
    },
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      this.modalTableData = [];
      sale.listDetailReport(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;

          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.saleOrderDetailCreateTime = utils.formatDate(result.saleOrderDetailCreateTime);
            result.saleOrderDetailManufactureDate = utils.formatDate(result.saleOrderDetailManufactureDate);
            result.saleOrderDetailIsRX = this.bool[result.saleOrderDetailIsRX - 1];
            result.saleOrderDetailIsEphedrine = this.bool[result.saleOrderDetailIsEphedrine - 1];
            result.isDtpStr = this.bool[result.saleOrderDetailIsDtp - 1];
            // result.profitRate += '%';
            // result.profitRateWithoutTax += '%';
            // result.financeInvoiceInvoiceDate = utils.formatTime(result.financeInvoiceInvoiceDate);
            // if (result.financeInvoiceStatus === 2) {
            //   result.financeInvoiceStatus = '已完结';
            // } else {
            //   result.financeInvoiceStatus = '未完结';
            // }
            result.id = result.saleOrderDetailId;
            result.saleOrderDetailOriginOutputTaxRate = result.saleOrderDetailOutputTaxRate;
            result.saleOrderDetailOriginOutputTaxRateStr = `${result.saleOrderDetailOutputTaxRate}%`;
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    submit() {
      const params = [];
      this.formModel.tableData.forEach((item) => {
        params.push({
          saleOrderDetailId: item.saleOrderDetailId,
          outputTaxRate: item.saleOrderDetailOutputTaxRate,
        });
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.outputTaxRateUpdateSubmit({ outputTaxVoList: params }).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.formModel.tableData.length === 0) {
        this.$Message.error('请先添加明细');
        return;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          let num = 0;
          this.formModel.tableData.forEach((item) => {
            if (item.saleOrderDetailOutputTaxRate === item.saleOrderDetailOriginOutputTaxRate) {
              num++;
              this.$Message.error(`商品编码${item.saleOrderDetailDrugSerialCode}未做任何更改，无需提交`);
            }
          });

          if (num === 0) {
            this.submitConfirmVisiable = true;
          }
        } else {
          this.$Message.error('请按照要求填写');
        }
      });
    },
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
  .red {
    color: red;
  }
</style>
